<template>
  <v-bottom-sheet
    v-model="showMainMenu"
    inset
    class="rounded"
    width="90%"
    v-if="$route.name !== 'NoAccess' && $route.name !== 'AccessDenied'"
  >
    <v-list density="comfortable">
      <v-toolbar density="compact" color="transparent">
        <v-toolbar-title>
          {{ salesTitle }}
        </v-toolbar-title>
        <template v-slot:append>
          <v-btn icon size="large" @click="showMainMenu = false">
            <v-icon>mdi-close</v-icon>
            <v-tooltip activator="parent" location="bottom">Close</v-tooltip>
          </v-btn>
        </template>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list-item @click="goBack">
        <template v-slot:prepend>
          <v-icon icon="mdi-form-select"></v-icon>
        </template>

        <template v-slot:title> Enter sales data </template>
        <template v-slot:subtitle> Enter sales data manually, one by one </template>
      </v-list-item>

      <v-list-item @click="openImport">
        <template v-slot:prepend>
          <v-icon icon="mdi-file-import-outline"></v-icon>
        </template>
        <template v-slot:title>Import</template>
        <template v-slot:subtitle>Import order details from platforms</template>
      </v-list-item>

      <v-list-item @click="openCoverage">
        <template v-slot:prepend>
          <v-icon icon="mdi-chart-box-outline"></v-icon>
        </template>
        <template v-slot:title>Coverage Report</template>
        <template v-slot:subtitle>Check sales data coverage</template>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item @click="goToSalesAnalytics">
        <template v-slot:prepend>
          <v-icon icon="mdi-chart-box-multiple-outline"></v-icon>
        </template>
        Sales Analytics
      </v-list-item>

      <v-list-item @click="goToSalesDaily">
        <template v-slot:prepend>
          <v-icon icon="mdi-calendar"></v-icon>
        </template>
        Daily Sales
      </v-list-item>

      <v-list-item @click="goToSalesAverages">
        <template v-slot:prepend>
          <v-icon icon="mdi-calculator"></v-icon>
        </template>
        Monthly Averages Sales
      </v-list-item>

      <v-list-item @click="goToSalesMonthly">
        <template v-slot:prepend>
          <v-icon icon="mdi-calendar-month"></v-icon>
        </template>
        Monthly Data Sales
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item @click="showRawData">
        <template v-slot:prepend>
          <v-icon icon="mdi-table"></v-icon>
        </template>
        <template v-slot:title> Manage Sales Data</template>
        <template v-slot:subtitle> Manage all sales records (list, update, delete) </template>
      </v-list-item>

      <template v-if="isRawDataRoute && exportCsvHandler">
        <v-divider></v-divider>
        <v-list-item @click="handleExportCsv">
          <template v-slot:prepend>
            <v-icon icon="mdi-file-delimited-outline"></v-icon>
          </template>
          <template v-slot:title>Export CSV</template>
          <template v-slot:subtitle>Export filtered sales data to CSV file</template>
        </v-list-item>
      </template>
    </v-list>
  </v-bottom-sheet>

  <!-- Dialog Components -->
  <CoverageReportDialog />
  <ImportOrderDetailsDialog />
</template>

<script setup>
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useApp } from "@/composables/useApp.js";
import { useSalesMenu } from "@/composables/useSalesMenu.js";
import CoverageReportDialog from "@/components/CoverageReportDialog.vue";
import ImportOrderDetailsDialog from "@/components/ImportOrderDetailsDialog.vue";

const router = useRouter();
const route = useRoute();
const { showMainMenu, salesTitle } = useApp();
const { openCoverageDialog, openImportDialog, exportCsvHandler } = useSalesMenu();

const isRawDataRoute = computed(() => route.path === "/admin/sales/raw-data");

// Navigation functions
function showRawData() {
  showMainMenu.value = false;
  router.push("/admin/sales/raw-data");
}

function goToSalesMonthly() {
  showMainMenu.value = false;
  router.push("/admin/sales/monthly");
}

function goToSalesDaily() {
  showMainMenu.value = false;
  router.push("/admin/sales/daily");
}

function goToSalesAnalytics() {
  showMainMenu.value = false;
  router.push("/admin/sales/analytics");
}

function goToSalesAverages() {
  showMainMenu.value = false;
  router.push("/admin/sales/monthly-averages");
}

function goBack() {
  showMainMenu.value = false;
  router.push("/accounting/sales");
}

function openImport() {
  showMainMenu.value = false;
  openImportDialog();
}

function openCoverage() {
  showMainMenu.value = false;
  openCoverageDialog();
}

function handleExportCsv() {
  showMainMenu.value = false;
  if (exportCsvHandler.value) exportCsvHandler.value();
}
</script>
